import './TableMargin.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import TableMarginHeader from './TableMarginHeader'
import TableMarginRow from './TableMarginRow'

const TableMargin = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxRevenue,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="table-margin">
      <TableMarginHeader className={headerClassName} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-margin-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxRevenue,
          showModal,
          stores,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableMarginRow}
      </List>
    </div>
  )
}

TableMargin.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxRevenue: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  type: PropTypes.string,
}

export default TableMargin
